<!-- #738: Drei Textzeilen plus Aktionsmenue (welche Eintraege, entscheidet der Status — siehe
     menuItems). Utility-Klassen direkt im Template — src/tailwind.css gibt es auf 4.0.x nicht.
     Der Rahmen gehoert der host-Klasse, hier also kein border-b. -->
<div class="flex flex-row items-start px-5 py-2 text-[14px] leading-[1.325rem]">

  <div class="flex flex-col grow min-w-0">

    <!-- Zeile 1: Status, Titel, Typ -->
    <div class="flex flex-row items-center flex-wrap gap-x-2">
      <p-tag
        [value]="statusLabelKey() | translate"
        [severity]="statusSeverity()">
      </p-tag>
      <!-- Korrekturmeldung (Client-Dok §8.2): dieselbe Aussage, die die zugehoerige Mail im
           Betreff („Korrektur:") schon traegt. Ohne sie stehen zwei fast gleiche Titel
           untereinander und niemand weiss, welcher gilt. -->
      @if (isCorrection()) {
        <p-tag
          [value]="'core.announcement.row.correctionBadge' | translate"
          [severity]="'info'">
        </p-tag>
      }
      <!-- Titel aus content.de.title: `de` ist die einzige Sprache, die der Server erzwingt. -->
      <span class="font-medium break-words">{{ title() }}</span>
      <span class="text-[#848488]">·</span>
      <!-- typeLabel kommt fertig uebersetzt vom Server, laeuft also NICHT durch die translate-Pipe.
           Fehlt es, steht hier der technische typeKey. -->
      <span class="text-[#848488] break-all">{{ typeDisplay() }}</span>
    </div>

    <!-- Zeile 2: Zielgruppe und Termin -->
    <div class="flex flex-row flex-wrap gap-x-2 text-[#848488]">
      @if (targeting().allTenants) {
        <span>{{ 'core.announcement.row.allTenants' | translate }}</span>
      } @else {
        <span>{{ 'core.announcement.row.tenantCount' | translate:{ count: targeting().tenantCount } }}</span>
      }
      @if (targeting().roleCount > 0) {
        <span>·</span>
        <span>{{ 'core.announcement.row.roleCount' | translate:{ count: targeting().roleCount } }}</span>
      }
      <span>·</span>
      <span>{{ 'core.announcement.row.scheduledAt' | translate }}: {{ announcement().scheduledAt | date:'dd.MM.yyyy HH:mm' }}</span>
    </div>

    <!-- Zeile 3: Fortschritt. Zaehlt MANDANTEN, nicht Empfaenger — der Schluessel schreibt das aus,
         damit niemand Reichweite hineinliest. Erst ab RUNNING, vorher waere „0 von n" irrefuehrend. -->
    @if (showProgress()) {
      <div class="text-[#848488]">{{ 'core.announcement.row.progress' | translate:progressParams() }}</div>
    }
  </div>

  <!-- Aktionen. Abbrechen nur solange SCHEDULED, Duplizieren immer. -->
  <div class="flex flex-col justify-center shrink-0 ml-2">
    <nx-default-button
      [icon]="'icon-options'"
      [menuItems]="menuItems()">
    </nx-default-button>
  </div>
</div>
